import { useQuery } from '@tanstack/react-query';

import type { GetRiskAssessmentsParams } from 'api/RiskAssessmentsApi';
import { RiskAssessmentsApi } from 'api/RiskAssessmentsApi';
import { RISK_ASSESSMENTS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useRiskAssessments(params?: GetRiskAssessmentsParams) {
  const riskAssessmentsApi = new RiskAssessmentsApi();
  const { userBankId } = useUser();

  const { data: riskAssessments, isLoading: isLoadingRiskAssessments } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [RISK_ASSESSMENTS_KEY, userBankId, 'list', params],
    queryFn: () => riskAssessmentsApi.getRiskAssessmentsForBank(userBankId, params)
  });

  return { riskAssessments, isLoadingRiskAssessments };
}
